<script>
  import { onMount } from "svelte";
  import Icon from "svelte-awesome";
  import {
    angleDoubleDown,
    angleDoubleUp,
    arrowUp,
    filter,
    sort,
  } from "svelte-awesome/icons";
  import { Badge, Table, Spinner, Fade, Button } from "sveltestrap";

  import axios from "axios";
  import { format as formatDate, addMonths, isThisMonth } from "date-fns";

  import ColumnFilterModal from '../ColumnFilterModal.svelte';
  import ResourceJobsContainer from "../containers/ResourceJobsContainer.svelte";
  import DataSpinner from "../Spinner.svelte";
  import NavbarSuccess from "../NavbarSuccess.svelte";

  let showContent = false;
  let toggle_show = () => (showContent = !showContent);
  let deliverableArray = null;
  let teams = null;
  let selectedTeam =
    localStorage.getItem("team") === null ? "" : localStorage.getItem("team");
  let show = false;
  let jobs = null;
  let fetchingScheduled = false;
  let fetchingUnscheduled = false;
  let scheduled = true;
  let productions = [];
  let productionCollapse = false;
  let selectAll = false;
  let productionFilter = null;
  let allScheduledTable = [];
  let scheduledTable = [];
  let allUnscheduledTable = [];
  let unscheduledTable = [];
  let user = "";
  let search = "";
  let filteredFields = {};
  let filteredFieldsExt = {};
  let dateFilterOptions = {
    ForContractSignedDate: '',
    ForFieldVerificationStartDate: '',
    ForJobDueDate: '',
  };

  let isLoadingProductionTotals = true;
  let productionTotalsByDate = {}; // of type { [key: string]: { period: Date, monthly: string, yearToDate: string } }
  let activeProductionTotal = {
    period: new Date(),
    monthly: '-',
    yearToDate: '-',
  };

  let columnFilterModal = { open: () => {} };

  onMount(async () => {
    await getUser();
    await getTeam();

    await getProductionTotals().then(() => isLoadingProductionTotals = false);
  });

  async function getUser() {
    const res = await fetch("/authentication/GetUserDetails");
    const json = await res.json();
    user = json.Result;
    if (user.Team !== 100000005) {
      selectedTeam = user.Team;
      localStorage.setItem("team", selectedTeam);
    }

    if (json.StatusCode === 401) {
      window.location = "login";
      document.title = "Login";
    } else {
      if (user.Type === 1) {
        document.onmousemove = function() {
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            handleLogout();
          }, 60000 * 25);
        };
      }
    }
  }

  function getJobList() {
    fetchingScheduled = true;
    scheduledTable = [];
    axios
      .get(
        `/resourceapi/GetJobListWithResource?teamId=${selectedTeam}` +
        `&filter=${productions}` +
        `&unScheduled=false` +
        `&searchText=${search}` +
        `&dateFilterJson=${encodeURI(JSON.stringify(dateFilterOptions))}`
      )
      .then(function(response) {
        allScheduledTable = response.data;
        scheduledTable = allScheduledTable.filter(filterData);
        fetchingScheduled = false;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function unscheduledJobList() {
    fetchingUnscheduled = true;
    allUnscheduledTable = [];
    axios
      .get(
        `/resourceapi/JobListUnscheduled?teamId=${selectedTeam}` +
        `&filter=${productions}` +
        `&unScheduled=false` +
        `&searchText=${search}` +
        `&dateFilterJson=${encodeURI(JSON.stringify(dateFilterOptions))}`
      )
      .then(function(response) {
        allUnscheduledTable = response.data;
        unscheduledTable = allUnscheduledTable.filter(filterData);
        fetchingUnscheduled = false;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  async function getTeam() {
    try {
      const response = await axios.get("/JobBoardApi/GetTeams");
      teams = response.data;
      getProductionStatus();
    } catch (error) {
      console.log(error);
    }
  }

  function getProductionStatus() {
    axios
      .get("ResourceApi/GetListOfProductionStatus")
      .then(function(response) {
        productionFilter = response.data;
        getJobList();
        unscheduledJobList();
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  async function fetchProductionTotalsByPeriod(period) {
    const res = await fetch(`resourceapi/GetProductionTotalSummary?monthPeriod=${period.toISOString()}`);
    const result = await res.json();

    const key = formatDate(period, 'MMMM yyyy');
    productionTotalsByDate[key] = {
      period: period,
      monthly: result.Monthly,
      yearToDate: result.YearToDate,
    };
    productionTotalsByDate = productionTotalsByDate;
  }

  async function getProductionTotals() {
    const key = formatDate(activeProductionTotal.period, 'MMMM yyyy');
    if (!productionTotalsByDate[key]) {
      isLoadingProductionTotals = true;

      await fetchProductionTotalsByPeriod(activeProductionTotal.period);

      isLoadingProductionTotals = false;
    }

    activeProductionTotal.period = productionTotalsByDate[key].period;
    activeProductionTotal.monthly = productionTotalsByDate[key].monthly;
    activeProductionTotal.yearToDate = productionTotalsByDate[key].yearToDate;
    activeProductionTotal = activeProductionTotal;
  }

  async function handleGetPrevProductionTotals() {
    activeProductionTotal.period = addMonths(activeProductionTotal.period, -1);
    activeProductionTotal = activeProductionTotal;
    await getProductionTotals();
  }

  async function handleGetNextProductionTotals() {
    activeProductionTotal.period = addMonths(activeProductionTotal.period, 1);
    activeProductionTotal = activeProductionTotal;
    await getProductionTotals();
  }


  function handleChangeTeam(e) {
    selectedTeam = e.target.value;
    localStorage.setItem("team", selectedTeam);
    getJobList();
    unscheduledJobList();
  }

  function handleSelectAll() {
    selectAll = !selectAll;
    if (selectAll === true) {
      productionFilter.map(x => productions.push(x.Value));
      productions = productions;
      getJobList();
      unscheduledJobList();
    } else {
      productions = [];
    }
  }

  function handleGetdata() {
    selectAll = false;
    getJobList();
    unscheduledJobList();
  }

  function filterColumn(field) {
    console.warn('filter:', field);
  }

  let sortPM = false;
  function sortByProjectManager() {
    sortPM = !sortPM;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.ProjectManager.toUpperCase();
      const managerB = b.ProjectManager.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortPM ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  function sortByUnscheduledProjectManager() {
    sortPM = !sortPM;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.ProjectManager.toUpperCase();
      const managerB = b.ProjectManager.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortPM ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }
  let sortJN = false;
  function sortByJobName() {
    sortJN = !sortJN;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.JobName.toUpperCase();
      const managerB = b.JobName.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortJN ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortFV= false;
  function sortByFieldVerify() {
    sortFV = !sortFV;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = (a.FieldVerify || '').toUpperCase();
      const managerB = (b.FieldVerify || '').toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortFV ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortCC = false;
  function sortByContractCompany() {
    sortCC = !sortCC;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.ContractCompany.toUpperCase();
      const managerB = b.ContractCompany.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortCC ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortNF = false;
  function sortByNoFloors() {
    sortNF = !sortNF;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.NoFloors.toUpperCase();
      const managerB = b.NoFloors.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortNF ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortJD = false;
  function sortByJobDueDate() {
    sortJD = !sortJD;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.JobDueDate.toUpperCase();
      const managerB = b.JobDueDate.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortJD ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortPS = false;
  function sortByProjectStatus() {
    sortPS = !sortPS;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.ProjectStatus.toUpperCase();
      const managerB = b.ProjectStatus.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortPS ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortCD = false;
  function sortByContractDate() {
    sortCD = !sortCD;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.ContractSignedDate.toUpperCase();
      const managerB = b.ContractSignedDate.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortCD ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortSD = false;
  function sortByStartDate() {
    sortSD = !sortSD;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.FieldCheckStartDate.toUpperCase();
      const managerB = b.FieldCheckStartDate.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortSD ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortBV = false;
  function sortByBMValue() {
    sortBV = !sortBV;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.BMValue.toUpperCase();
      const managerB = b.BMValue.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortBV ? comparison : comparison * -1;
    }
    scheduledTable = allScheduledTable.filter(filterData).sort(compare);
  }

  let sortUJN = false;
  function sortByUnscheduledJobName() {
    sortUJN = !sortUJN;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.JobName.toUpperCase();
      const managerB = b.JobName.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortUJN ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }

  let sortUFV= false;
  function sortByUnscheduledFieldVerify() {
    sortUFV = !sortUFV;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = (a.FieldVerify || '').toUpperCase();
      const managerB = (b.FieldVerify || '').toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortUFV ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }

  let sortUCC = false;
  function sortByUnscheduledContractCompany() {
    sortUCC = !sortUCC;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.ContractCompany.toUpperCase();
      const managerB = b.ContractCompany.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortUCC ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }

  let sortUNF = false;
  function sortByUnscheduledNoFloors() {
    sortUNF = !sortUNF;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.NoFloors.toUpperCase();
      const managerB = b.NoFloors.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortUNF ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }

  let sortUPS = false;
  function sortByUnscheduledProjectStatus() {
    sortUPS = !sortUPS;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.ProjectStatus.toUpperCase();
      const managerB = b.ProjectStatus.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortUPS ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }

  let sortUCD = false;
  function sortByUnscheduledContractDate() {
    sortUCD = !sortUCD;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.ContractSignedDate.toUpperCase();
      const managerB = b.ContractSignedDate.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortUCD ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }

  let sortUSD = false;
  function sortByUnscheduledStartDate() {
    sortUSD = !sortUSD;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.FieldCheckStartDate.toUpperCase();
      const managerB = b.FieldCheckStartDate.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortUSD ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }

  let sortUBV = false;
  function sortByUnscheduledBMValue() {
    sortUBV = !sortUBV;
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const managerA = a.BMValue.toUpperCase();
      const managerB = b.BMValue.toUpperCase();

      let comparison = 0;
      if (managerA > managerB) {
        comparison = 1;
      } else if (managerA < managerB) {
        comparison = -1;
      }
      return sortUBV ? comparison : comparison * -1;
    }
    unscheduledTable = allUnscheduledTable.filter(filterData).sort(compare);
  }

  function showColumnFilterModal(field, value, options = {}) {
    columnFilterModal.show(field, value, filteredFields[field], options, filteredFieldsExt[field]);
  }

  function updateFilters(filterResult) {
    filteredFields = filteredFields || {};
    filteredFields[filterResult.field] = filterResult.value;
    filteredFields = filteredFields;

    filteredFieldsExt = filteredFieldsExt || {};
    filteredFieldsExt[filterResult.field] = filterResult.extData;
    filteredFieldsExt = filteredFieldsExt;

    dateFilterOptions = { };
    if (!!filteredFieldsExt['ContractSignedDate']) {
      dateFilterOptions.ForContractSignedDate = filteredFieldsExt['ContractSignedDate'].dateFilter;
    }

    if (!!filteredFieldsExt['FieldCheckStartDate']) {
      dateFilterOptions.ForFieldCheckStartDate = filteredFieldsExt['FieldCheckStartDate'].dateFilter;
    }

    if (!!filteredFieldsExt['JobDueDate']) {
      dateFilterOptions.ForJobDueDate = filteredFieldsExt['JobDueDate'].dateFilter;
    }

    selectAll = false;
    getJobList();
    unscheduledJobList();

    scheduledTable = allScheduledTable.filter(filterData);
    unscheduledTable = allUnscheduledTable.filter(filterData);
  }

  function filterData(item) {
    let isMatch = true;

    for (const key in filteredFields) {
      if (filteredFields.hasOwnProperty(key)) {
        const searchTerm = (filteredFields[key] || '').toLowerCase();

        let fieldRawValue = '';
        switch (key) {
          case 'FieldVerify':
            fieldRawValue = item[key] == 'True' ? 'Yes' : 'No';
            break;

          default:
            fieldRawValue = item[key] || '';
            break;
        }

        const fieldValue = fieldRawValue.toString().toLowerCase();

        isMatch = isMatch && fieldValue.includes(searchTerm);
      }
    }

    return isMatch;
  }

  function handleSearch() {
    if (allScheduledTable.length <= 0) {
      dateFilterOptions = {};
      filteredFieldsExt = {};
      filteredFields = {};
    }

    unscheduledJobList();
    getJobList();
  }

  function clearSearch() {
    search = "";
    handleSearch();
  }

  function handleEnterSearch(e) {
    if (e.keyCode === 13) {
      unscheduledJobList();
      getJobList();
    }
  }
</script>

<style>
  select {
    width: 30%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  .resourcing-container {
    margin: 50px 45px;
    display: grid;
    grid-template-areas: "filter totals" "search totals" "grid grid";
  }
  .resourcing-filter-sec {
    display: flex;
    grid-area: filter;
  }
  .resourcing-filter-sec span {
    padding-top: 8px;
    font-size: 15px;
    padding-right: 12px;
  }
  .resourcing-filter-sec select {
    margin-left: 5px;
    display: block;
    width: 50%;
    height: calc(2.5rem + 2px);
    padding: 5px;
    border: 1px solid #ced4da;
    border-radius: 0;
    font-size: 13px;
  }

  .resource-search {
    margin-top: 10px;
    display: flex;
    grid-area: search;
  }

  .resource-search input {
    padding: 8px 11px;
    margin-right: 12px;
    width: 50%;
    height: calc(2.5rem + 2px);
    color: #495057;
    border: 1px solid #ced4da;
    border-radius: 0;
    font-size: 13px;
    margin-left: 54px;
  }

  .resource-search span {
    margin: 6px 20px 0px -26px;
    cursor: pointer;
    font-weight: bold;
  }

  .resourcing-production-totals {
    font-weight: bold;
    grid-area: totals;
    display: flex;
    flex-direction: row;
    text-align: center;
  }

  .resourcing-production-totals > .controls {
    font-weight: bold;
    grid-area: totals;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 40%;
  }

  .resourcing-production-totals > .controls > .period-selector > button {
    background: none;
    border: none;
    color: #b8b8b8;
  }

  .resourcing-production-totals > .controls > .period-selector > button.prev {
    clip-path: polygon(0 50, 0 100, 100 100, 0 50);
  }

  .resourcing-production-totals > .controls > .period-selector > button.next {
    clip-path: polygon(0 0, 100 50, 100 50, 0 100);
  }

  .resourcing-production-totals > .controls > .totals-box {
    display:  flex;
    flex-direction: column;
    text-align: center;
    border: 2px solid black;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .tab-header {
    display: flex;
    width: 100%;
    font-size: 12px;
  }
  .tab-links {
    width: 100%;
    text-align: center;
    padding: 10px;
    background-color: #0984e3;
    color: #fff;
    font-weight: bold;
  }
  .inactive-tab-links {
    width: 100%;
    text-align: center;
    padding: 10px;
    border: 1px solid #223646;
    background-color: #fff;
    color: #223646;
    cursor: pointer;
  }
  .column-header {
    cursor: pointer;
    background-color: #fff;
    position: sticky;
    top: -1px;
    vertical-align: middle;
    text-align: center;
  }

  .column-header:hover {
    background-color: #f1f2f6;
  }
  td {
    white-space: nowrap;
    overflow: hidden;
  }
  .resourcing-table {
    margin-top: 50px;
    font-size: 11px;
    border: 1px solid #dee2e6;
    grid-area: grid;
  }
  .resourcing-table .tab-links {
    background-color: #223646;
  }
  .resourcing-table-data {
    overflow: hidden auto;
    min-height: 400px !important;
  }
  .res-view-title {
    display: none;
  }
  .no-data-container {
    margin: 80px auto;
    width: 100%;
    text-align: center;
  }

  @media (max-width: 768px) {
    .resourcing-filter-sec select,
    .resource-search input {
      width: 300px;
    }

    .res-view-title {
      display: block;
    }
  }
  @media (max-width: 426px) {
    .resourcing-container {
      margin: 20px 10px;
    }
    .resourcing-table {
      margin-top: 30px;
    }
  }
  @media (max-width: 320px) {
    .resourcing-filter-sec select,
    .resource-search input {
      width: 175px;
    }
  }
</style>

<NavbarSuccess />
<div class="resourcing-container">
  <div class="resourcing-filter-sec">
    <span>Team:</span>
    <select value={selectedTeam} on:change={handleChangeTeam}>
      {#if teams != null}
        {#each teams as team}
          <option
            value={team.Value}
            selected={localStorage.getItem('team') === team.Value ? true : false}>
            {team.Label}
          </option>
        {/each}
      {:else}
        <select>
          <option />
        </select>
        <Spinner
          size="sm"
          style="position: absolute; margin-top: 15px; margin-left: 18px;" />
      {/if}
    </select>
    <div class="filter-btn">
      <!--<Button on:click={() => (productionCollapse = !productionCollapse)}>-->
      <Button>Filter</Button>
      <div class="filter-option-container" />
      <!--{#if productionCollapse}-->
      <div class="filter-option">
        <input
          type="checkbox"
          style="margin-top: 7px; margin-right: 5px"
          checked={selectAll}
          on:click={handleSelectAll} />
        <label>Select All</label>
        <div>
          {#if productionFilter !== null}
            {#each productionFilter as filter}
              <div>
                <input
                  type="checkbox"
                  style="margin-top: 7px; margin-right: 5px"
                  bind:group={productions}
                  value={filter.Value}
                  on:change={handleGetdata} />
                <label style="margin-right: 10px">
                  {filter.Label.UserLocalizedLabel.Label}
                </label>
              </div>
            {/each}
          {/if}
        </div>
      </div>
      <!--{/if}-->
    </div>
  </div>
  <div class="resource-search">
    <input type="text" on:keyup={handleEnterSearch} bind:value={search} />
    <span on:click={clearSearch}>x</span>
    <Button color="primary" on:click={handleSearch} class="search-btn">
      Search
    </Button>
  </div>
  <div class="resourcing-production-totals">
    <span>Production Totals</span>
    <div class="controls">
      <div class="period-selector">
        <button class="prev" on:click={handleGetPrevProductionTotals}>
          <span class="fa fa-caret-left"></span>
        </button>
        <span>{formatDate(activeProductionTotal.period, 'MMMM yyyy')}</span>
        <button class="next" on:click={handleGetNextProductionTotals}>
          <span class="fa fa-caret-right"></span>
        </button>
      </div>
      <div class="totals-box">
        {#if !isLoadingProductionTotals}
          <span class="monthly">Monthly Total: {activeProductionTotal.monthly}</span>
          <span class="year-to-date">YTD Total: {activeProductionTotal.yearToDate}</span>
        {:else}
          <Spinner size="xs" style="width: 50px; height: 50px;" />
        {/if}
      </div>
    </div>
  </div>
  <div class="resourcing-table">
    <div class="tab-header">
      <div
        class={scheduled ? 'tab-links' : 'inactive-tab-links'}
        on:click={() => (scheduled = true)}>
        Scheduled
      </div>
      <div
        class={scheduled ? 'inactive-tab-links' : 'tab-links'}
        on:click={() => (scheduled = false)}>
        Unscheduled
      </div>
    </div>
    <div class="with-scroll resourcing-table-data">
      {#if scheduled && allScheduledTable !== null}
        <Table bordered responsive style="width:101%">
          <thead>
            <tr>
              <th class="column-header">
                <span on:click={sortByJobName}>
                  Job Name
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('JobName', 'Job Name')}>
                  <Icon data={filter} style="color: {!!filteredFields['JobName'] || filteredFieldsExt['JobName'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByFieldVerify}>
                  Field Verify
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('FieldVerify', 'Field Verify')}>
                  <Icon data={filter} style="color: {!!filteredFields['FieldVerify'] || filteredFieldsExt['FieldVerify'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByProjectManager}>
                  Project Manager
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ProjectManager', 'Project Manager')}>
                  <Icon data={filter} style="color: {!!filteredFields['ProjectManager'] || filteredFieldsExt['ProjectManager'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByContractCompany}>
                  Contract Company
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ContractCompany', 'Contract Company')}>
                  <Icon data={filter} style="color: {!!filteredFields['ContractCompany'] || filteredFieldsExt['ContractCompany'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByNoFloors}>
                  No. of Floors
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('NoFloors', 'No. of Floors')}>
                  <Icon data={filter} style="color: {!!filteredFields['NoFloors'] || filteredFieldsExt['NoFloors'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByContractDate}>
                  Contract Signed Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ContractSignedDate', 'Contract Signed Date', { useDateFilter: true })}>
                  <Icon data={filter} style="color: {!!filteredFields['ContractSignedDate'] || filteredFieldsExt['ContractSignedDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByStartDate}>
                  Field Verification Start Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('FieldCheckStartDate', 'Field Verification Start Date', { useDateFilter: true })}>
                  <Icon data={filter} style="color: {!!filteredFields['FieldCheckStartDate'] || filteredFieldsExt['FieldCheckStartDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByJobDueDate}>
                  Due Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('JobDueDate', 'Due Date', { useDateFilter: true })}>
                  <Icon data={filter} style="color: {!!filteredFields['JobDueDate'] || filteredFieldsExt['JobDueDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByProjectStatus}>
                  Current Status
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ProjectStatus', 'Current Status')}>
                  <Icon data={filter} style="color: {!!filteredFields['ProjectStatus'] || filteredFieldsExt['ProjectStatus'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByBMValue}>
                  BM Value
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('BMValue', 'BM Value')}>
                  <Icon data={filter} style="color: {!!filteredFields['BMValue'] || filteredFieldsExt['BMValue'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {#each scheduledTable as scheduled}
              <tr>
                <th scope="row">
                  <span class="res-view-title">Job Name</span>
                  <a href="/board?q={scheduled.JobName}">
                    {scheduled.JobName}
                  </a>
                </th>
                <td>
                  <span class="res-view-title">Field Verify</span>
                  {scheduled.FieldVerify == 'True' ? 'Yes' : 'No'}
                </td>
                <td>
                  <span class="res-view-title">Project Manager</span>
                  {scheduled.ProjectManager}
                </td>
                <td>
                  <span class="res-view-title">Contract Company</span>
                  {scheduled.ContractCompany}
                </td>
                <td>
                  <span class="res-view-title">No. of Floors</span>
                  {scheduled.NoFloors}
                </td>
                <td>
                  <span class="res-view-title">Contract Signed Date</span>
                  {scheduled.ContractSignedDate}
                </td>
                <td>
                  <span class="res-view-title">Field Check Start Date</span>
                  {scheduled.FieldCheckStartDate}
                </td>
                <td>
                  <span class="res-view-title">Job Due Date</span>
                  {scheduled.JobDueDate}
                </td>
                <td>
                  <span class="res-view-title">Project Status</span>
                  {scheduled.ProjectStatus}
                </td>
                <td>
                  <span class="res-view-title">BM Value</span>
                  {scheduled.BMValue}
                </td>
              </tr>
            {/each}
          </tbody>
        </Table>
        {#if fetchingScheduled && allScheduledTable.length <= 0}
          <div style="margin: 100px auto;">
            <DataSpinner />
          </div>
        {:else if allScheduledTable.length === 0}
          <div class="no-data-container">
            <h3>No Data</h3>
          </div>
        {/if}
      {/if}
      {#if !scheduled && unscheduledTable !== null}
        <Table bordered responsive style="width:101%">
          <thead>
            <tr>
              <th class="column-header">
                <span on:click={sortByUnscheduledJobName}>
                  Job Name
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('JobName', 'Job Name')}>
                  <Icon data={filter} style="color: {!!filteredFields['JobName'] || filteredFieldsExt['JobName'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByUnscheduledFieldVerify}>
                  Field Verify
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('FieldVerify', 'Field Verify')}>
                  <Icon data={filter} style="color: {!!filteredFields['FieldVerify'] || filteredFieldsExt['FieldVerify'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByUnscheduledProjectManager}>
                  Project Manager
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ProjectManager', 'Project Manager')}>
                  <Icon data={filter} style="color: {!!filteredFields['ProjectManager'] || filteredFieldsExt['ProjectManager'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByUnscheduledContractCompany}>
                  Contract Company
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ContractCompany', 'Contract Company')}>
                  <Icon data={filter} style="color: {!!filteredFields['ContractCompany'] || filteredFieldsExt['ContractCompany'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByUnscheduledNoFloors}>
                  No. of Floors
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('NoFloors', 'No. of Floors')}>
                  <Icon data={filter} style="color: {!!filteredFields['NoFloors'] || filteredFieldsExt['NoFloors'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByUnscheduledContractDate}>
                  Contract Signed Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ContractSignedDate', 'Contract Signed Date', { useDateFilter: true })}>
                  <Icon data={filter} style="color: {!!filteredFields['ContractSignedDate'] || filteredFieldsExt['ContractSignedDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByJobDueDate}>
                  Due Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('JobDueDate', 'Due Date', { useDateFilter: true })}>
                  <Icon data={filter} style="color: {!!filteredFields['JobDueDate'] || filteredFieldsExt['JobDueDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByUnscheduledProjectStatus}>
                  Current Status
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ProjectStatus', 'Current Status')}>
                  <Icon data={filter} style="color: {!!filteredFields['ProjectStatus'] || filteredFieldsExt['ProjectStatus'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th class="column-header">
                <span on:click={sortByUnscheduledBMValue}>
                  BM Value
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('BMValue', 'BM Value')}>
                  <Icon data={filter} style="color: {!!filteredFields['BMValue'] || filteredFieldsExt['BMValue'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {#each unscheduledTable as scheduled}
              <tr>
                <th scope="row">
                  <span class="res-view-title">Job Name</span>
                  {scheduled.JobName}
                </th>
                <td>
                  <span class="res-view-title">Field Verify</span>
                  {scheduled.FieldVerify == 'True' ? 'Yes' : 'No'}
                </td>
                <td>
                  <span class="res-view-title">Project Manager</span>
                  {scheduled.ProjectManager}
                </td>
                <td>
                  <span class="res-view-title">Contract Company</span>
                  {scheduled.ContractCompany}
                </td>
                <td>
                  <span class="res-view-title">No. of Floors</span>
                  {scheduled.NoFloors}
                </td>
                <td>
                  <span class="res-view-title">Contract Signed Date</span>
                  {scheduled.ContractSignedDate}
                </td>
                <td>
                  <span class="res-view-title">Job Due Date</span>
                  {scheduled.JobDueDate}
                </td>
                <td>
                  <span class="res-view-title">Project Status</span>
                  {scheduled.ProjectStatus != null ? scheduled.ProjectStatus : ''}
                </td>
                <td>
                  <span class="res-view-title">BM Value</span>
                  {scheduled.BMValue}
                </td>
              </tr>
            {/each}
          </tbody>
        </Table>
        {#if fetchingUnscheduled && allUnscheduledTable.length <= 0}
          <div style="margin: 100px auto;">
            <DataSpinner />
          </div>
        {:else if allUnscheduledTable.length === 0}
          <div class="no-data-container">
            <h3>No Data</h3>
          </div>
        {/if}
      {/if}
    </div>
  </div>
</div>

<ColumnFilterModal bind:this={columnFilterModal} on:filter={evt => updateFilters(evt.detail)}></ColumnFilterModal>
